export default __webpack_public_path__ + "static/media/icon-pattern-testomonia.1e2483bd.svg";